// create
export const CREATE_DISBURSE_TYPE_REQUEST = "CREATE_DISBURSE_TYPE_REQUEST";
export const CREATE_DISBURSE_TYPE_SUCCESS = "CREATE_DISBURSE_TYPE_SUCCESS";
export const CREATE_DISBURSE_TYPE_FAIL = "CREATE_DISBURSE_TYPE_FAIL";

// get
export const DISBURSE_TYPE_REQUEST = "DISBURSE_TYPE_REQUEST";
export const DISBURSE_TYPE_SUCCESS = "DISBURSE_TYPE_SUCCESS";
export const DISBURSE_TYPE_FAIL = "DISBURSE_TYPE_FAIL";

// find
export const FIND_DISBURSE_TYPE_REQUEST = "FIND_DISBURSE_TYPE_REQUEST";
export const FIND_DISBURSE_TYPE_SUCCESS = "FIND_DISBURSE_TYPE_SUCCESS";
export const FIND_DISBURSE_TYPE_FAIL = "FIND_DISBURSE_TYPE_FAIL";

// update
export const UPDATE_DISBURSE_TYPE_REQUEST = "UPDATE_DISBURSE_TYPE_REQUEST";
export const UPDATE_DISBURSE_TYPE_SUCCESS = "UPDATE_DISBURSE_TYPE_SUCCESS";
export const UPDATE_DISBURSE_TYPE_FAIL = "UPDATE_DISBURSE_TYPE_FAIL";

// delete
export const DELETE_DISBURSE_TYPE_REQUEST = "DELETE_DISBURSE_TYPE_REQUEST";
export const DELETE_DISBURSE_TYPE_SUCCESS = "DELETE_DISBURSE_TYPE_SUCCESS";
export const DELETE_DISBURSE_TYPE_FAIL = "DELETE_DISBURSE_TYPE_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";
